

const SvgIcons = (props) => {
    return (
        <>
            {props.iconName == 'caret-forward' &&

                <svg className={props.classList} focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 17l5-5-5-5v10z"></path></svg>}
        </>
    );
}

export default SvgIcons;